/* MatchCountComponent.js */

"use strict";

const EventEmitter = require("events");
const _ = require("lodash");
const Renderer = require("./MatchCountRenderer");

class MatchCountComponent extends EventEmitter {
    constructor(value, context) {
        super();
        this._value = value;
        this._adhocDetails = context.adhocDetails;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._entity = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setMatchCount(newVal);
        }
    }

    getValue() {
        return this.getMatchCount();
    }

    setMatchCount() {
        this.emit("MatchCount");
        return this;
    }

    getMatchCount() {
        if (_.get(this._adhocDetails, "_adHocRun", false) || _.get(this._adhocDetails, "_lastRunSelected", false)) {
            let lastRun = false;
            if (this._adhocDetails._adHocQueryExecutionEntityGen && this._adhocDetails._adHocQueryExecutionEntityGen.getLastRun() === true) {
                if (this._adhocDetails._adHocQueryExecutionEntityGen.getStatus() === "RUNNING") {
                    return "...";
                }
                lastRun = true;
            } else if (this._adhocDetails._proxyExecutionEntity && this._adhocDetails._proxyExecutionEntity.getLastRun() === true) {
                lastRun = true;
            }
            if (lastRun) {
                if (this._value.getStatus() === "PENDING") {
                    return "...";
                }
                if (!_.isUndefined(this._value.getMatchCount())) {
                    return this._value.getMatchCount();
                }
            }
        }
        return "N/A";
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = MatchCountComponent;
